export type WidgetBehaviorType = 'onlyAnon' | 'onlyAuth' | 'bothAnonAuth';

export const widgetStates = ['dialog', 'button', 'chat'] as const;
export type WidgetState = (typeof widgetStates)[number];

export type WidgetAppParams = {
  widgetAppName: string;
  requiredSSOName?: string;
  behaviorType: WidgetBehaviorType;
  supportsJwt?: boolean;
};

export const widgetButtonIcons = [
  'chat',
  'search',
  'assistance',
  'ai-assistant',
  'chat-and-search',
  'interactive-search',
  'faq',
  'chevron-down',
  'none',
] as const;

export type ButtonIconName = (typeof widgetButtonIcons)[number];

// `auto` resolves per link: same origin as the host page -> `_top` when the chat
// is embedded in an iframe (`_self` when standalone), anything else -> `_blank`.
export const linkTargets = ['_blank', '_self', '_top', '_parent', 'auto'] as const;

export type LinkTarget = (typeof linkTargets)[number];

export type WorknetWidgetConfig = {
  widgetKey: string;
  jwt?: string; // Optional JWT token from host page

  // custom config for dev override. usually inferred from widget
  chatBaseUrl: string;
  apiBaseUrl: string;

  groupingId?: string;

  customContext?: Record<string, unknown>;

  styles: {
    primary: string;
    secondary: string;
    tertiary: string;
    topOffset: string; // TODO: support margin of all sides and more forms of chat window
    width: string; // TODO: support sizes of all sides and items and more forms of chat window
    zIndex: number;
    bubbleZIndex?: number;
    side: 'left' | 'right';
  };

  button: {
    icon: ButtonIconName;
    text: string | undefined;
    isHidden: boolean;
    isColorsReversed: boolean;
  };

  chat: {
    isDrawer: boolean;
    linkTarget: LinkTarget;
    header: {
      text: string;
    };
    footer: {
      isHidden: boolean;
      text: string;
      privacyPolicyText: string;
      privacyPolicyUrl: string;
    };
  };

  nudgeBox: {
    maxWidthCenter: string;
    maxWidthSide: string;
    maxWidthTooltip: string;
  };
};
